import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

// prettier-ignore
export const wantedVehiclesGridColumns = [
  { label: 'Registrační značka', field: 'vehicleRegistrationNumber', displayField: 'vehicle', mapper: parent => get(parent, 'registrationNumber'), type: ColumnType.TEXT, width: 80 },
  { label: 'VIN', field: 'vehicleVinNumber', displayField: 'vehicle', mapper: parent => get(parent, 'vinNumber'), type: ColumnType.TEXT, width: 80 },
  { label: 'Druh', field: 'vehicleType.name', displayField: 'vehicle', mapper: parent => get(parent, 'type'), type: ColumnType.TEXT, width: 80 },
  { label: 'Barva', field: 'vehicleColor.name', displayField: 'vehicle', mapper: parent => get(parent, 'color'), type: ColumnType.TEXT, width: 80 },
  { label: 'Značka', field: 'vehicleBrand.name', displayField: 'vehicle', mapper: parent => get(parent, 'brand'), type: ColumnType.TEXT, width: 80 },
  { label: 'Držitel', field: 'vehicleOwner', displayField: 'vehicle', mapper: parent => get(parent, 'owner.fullName'), type: ColumnType.TEXT, width: 80 }
];



// WEBPACK FOOTER //
// ./src/modules/wantedVehicles/_wantedVehiclesColumns.ts